define(
//begin v1.x content
({
	invalidMessage: "Sisestatud väärtus ei sobi.",
	missingMessage: "See väärtus on kohustuslik.",
	rangeMessage: "See väärtus on lubatud vahemikust väljas."
})
//end v1.x content
);
